import Hero from "@/components/Hero";
import Manifesto from "@/components/Manifesto";
import Paths from "@/components/Paths";
import WorkGlimpses from "@/components/WorkGlimpses";
import IntakeTeaser from "@/components/IntakeTeaser";
import { Seo } from "@/components/Seo";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo path="/" />
      <Hero />
      <Manifesto />
      <Paths />
      <WorkGlimpses />
      <IntakeTeaser />
    </div>
  );
}
